// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__203nf","head":"Table_head__3jBM1","col":"Table_col__Uo3HV"};